import { combineReducers } from 'redux';
import { localeReducer } from 'react-localize-redux';
import { routerReducer } from 'react-router-redux';
import session from './session';
import destination from './destination';
import deviations from './deviation';
import serviceReport from './servicereport';
import workList from './worklist';
import navbar from './navbar';
import customer from './customer';
import { SESSION_LOGOUT } from '../actions/session';

const mainReducer = combineReducers({
  locale: localeReducer,
  router: routerReducer,
  session,
  destination,
  deviations,
  serviceReport,
  workList,
  navbar,
  customer,
});

const rootReducer = (state, action) => {
  let newState = state;

  if (action.type === SESSION_LOGOUT) {
    const { locale } = state;

    newState = {
      locale,
    };
  }

  return mainReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootreducer.js